import React from "react";
import { UncontrolledSidebar } from "@nef/core";
import styled from "styled-components";

const StyledUncontrolledSidebar = styled(UncontrolledSidebar)`
  &.uncontrolled-sidebar {
    z-index: 100;
    div {
      div.sidebar--bottom-multi-row {
        display: none !important;
      }
    }

    .sidebar-toggle-button--sub-button{
      padding: 0px !important;
      min-height: 36px !important;
    }
  }
`;

export default StyledUncontrolledSidebar;
